import { courseExerciseStatus } from 'constants/tests';
import { colors } from 'global/colors';

export const getHeightOfContainer = (totalItems, isMobile) => {
  const desktopHeights = {
    2: '200px',
    3: '240px',
    4: '310px',
    5: '300px',
    6: '330px',
    7: '430px',
    8: '540px',
    9: '600px',
    10: '740px',
  };

  const mobileHeights = {
    2: '180px',
    3: '240px',
    4: '320px',
    5: '350px',
    6: '450px',
    7: '550px',
    8: '650px',
    9: '680px',
    10: '780px',
  };

  const heights = isMobile ? mobileHeights : desktopHeights;
  return heights[totalItems] || '';
};

export const getTopCalculation = (totalItems, index, isMobile) => {
  const desktopTops = {
    1: [0],
    2: [0, 80],
    3: [0, 80, 120],
    4: [0, 80, 40, 120],
    5: [0, 80, 0, 80, 60],
    6: [0, 80, 0, 80, 60, 120],
    7: [0, 80, 0, 80, 60, 160, 220],
    8: [0, 80, 0, 80, 60, 160, 260, 200],
    9: [0, 80, 0, 80, 60, 160, 260, 220, 260],
    10: [0, 80, 0, 80, 60, 160, 260, 240, 340, 520],
  };

  const mobileTops = {
    1: [0],
    2: [0, 40],
    3: [0, 80, 20],
    4: [0, 80, 60, 240],
    5: [80, 0, 80, 60, 120],
    6: [80, 0, 80, 60, 160, 100],
    7: [80, 0, 80, 60, 160, 140, 300],
    8: [80, 0, 80, 60, 160, 140, 360, 200],
    9: [80, 0, 80, 60, 160, 120, 320, 180, 340],
    10: [80, 0, 80, 60, 160, 120, 320, 180, 400, 220],
  };

  const tops = isMobile ? mobileTops : desktopTops;
  return tops[totalItems]?.[index] ?? 0;
};

export const getOrderOfLevels = (levelNames, isMobile) => {
  const desktopColumns = [[], [], [], []];
  const mobileColumns = [[], [], []];

  const desktopItemPlacementOrder = [
    [1],
    [1, 2],
    [1, 2, 3],
    [1, 2, 1, 2],
    [0, 1, 2, 3, 2],
    [0, 1, 2, 3, 2, 1],
    [0, 1, 2, 3, 2, 1, 0],
    [0, 1, 2, 3, 2, 1, 0, 1],
    [0, 1, 2, 3, 2, 1, 0, 1, 2],
    [0, 1, 2, 3, 2, 1, 0, 1, 2, 3],
    [0, 1, 2, 3, 2, 1, 0, 1, 2, 3, 2],
  ];

  const mobileItemPlacementOrder = [
    [1],
    [1, 2],
    [1, 2, 1],
    [1, 2, 1, 0],
    [0, 1, 2, 1, 0],
    [0, 1, 2, 1, 0, 1],
    [0, 1, 2, 1, 0, 1, 2],
    [0, 1, 2, 1, 0, 1, 2, 1],
    [0, 1, 2, 1, 0, 1, 2, 1, 0],
    [0, 1, 2, 1, 0, 1, 2, 1, 0, 1],
    [0, 1, 2, 1, 0, 1, 2, 1, 0, 1, 2],
  ];

  const columns = isMobile ? mobileColumns : desktopColumns;
  const itemPlacementOrder = isMobile ? mobileItemPlacementOrder : desktopItemPlacementOrder;

  const levels = [...levelNames, { levelName: '', isCompleted: false, isExtraDiv: true }];
  const order = itemPlacementOrder[levels.length - 1];

  levels.forEach((level, index) => {
    columns[order[index]].push({ level, index, isExtraDiv: level.isExtraDiv });
  });

  return { levels, columns };
};

export const getColorForIcons = (status) => {
  switch (status) {
    case courseExerciseStatus.CURRENT:
      return colors.lightBlue16;
    case courseExerciseStatus.COMPLETED:
      return colors.green4;
    case courseExerciseStatus.UNLOCKED:
      return colors.lightGray7;
    default:
      return colors.lightGray17;
  }
};

export const getCharacterProperties = (items, isMobile) => {
  const desktopStyles = {
    2: { left: 10 },
    3: { left: 10 },
    4: { right: 10 },
    5: { left: 10 },
    6: { left: 10 },
    7: { left: 10 },
    8: { right: 10 },
    9: { right: 10 },
    10: { left: 10 },
    default: { left: 10 },
  };

  const mobileStyles = {
    2: { left: 10 },
    3: { left: 10 },
    4: { left: 10, transform: 'scaleX(-1)' },
    5: { left: 10 },
    6: { right: 10, transform: 'scaleX(-1)' },
    7: { right: 10, transform: 'scaleX(-1)' },
    8: { left: 10, transform: 'scaleX(-1)' },
    9: { right: 10 },
    10: { right: 10, transform: 'scaleX(-1)' },
    default: { left: 10 },
  };

  const styles = isMobile ? mobileStyles : desktopStyles;
  return styles[items] || styles.default;
};
